import SpinningWheel from './SpinningWheel';
export default SpinningWheel;
